// import axios from 'axios';

export default {
  namespaced: true,
  
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    isAuthenticated: localStorage.getItem('isAuthenticated') === 'true',
    loading: false,
    error: null
  },
  
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    currentUser: state => state.user,
    userLevel: state => {
      const level = state.user?.level;
      return level ? level.toString().trim().toUpperCase() : null;
    },
    userCompany: state => {
      const company = state.user?.company;
      return company ? company.toString().trim() : null;
    },
    isSuperAdmin: state => {
      const level = state.user?.level;
      return level ? level.toString().trim().toUpperCase() === 'SUPERADMIN' : false;
    },
    isCompanyAdmin: state => {
      const level = state.user?.level;
      return level ? level.toString().trim().toUpperCase() === 'ADMIN' : false;
    }
  },
  
  mutations: {
    setUser(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('isAuthenticated', !!user);
    },
    
    setAuthStatus(state, status) {
      state.isAuthenticated = status;
      localStorage.setItem('isAuthenticated', status);
    },
    
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    
    setError(state, error) {
      state.error = error;
    },
    
    clearError(state) {
      state.error = null;
    }
  },
  
  actions: {
    async login({ commit }, credentials) {
      commit('setLoading', true);
      commit('clearError');
      
      try {
        const response = await window.axios.post(window.bankApi + 'Super_admin/login', {
          email: credentials.email,
          password: credentials.password,
          localid: generateUUID()
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Api-Key': 'f6fef6af-0fca-49fe-bec4-89ddb6d24502'
          }
        });
        
        if (response.data.response) {
          const user = response.data.response

          localStorage.setItem('user', JSON.stringify(user));
          localStorage.setItem('isAuthenticated', true);
          commit('setUser', user);
          commit('setAuthStatus', true);
          return true;
        }
        
        throw new Error('Login failed: Invalid response from server');
      } catch (error) {
        errorHandler.tomcatError(error)
        commit('setAuthStatus', false);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    
    async logout({ commit }) {
      localStorage.removeItem('user');
      localStorage.removeItem('isAuthenticated');
      commit('setUser', null);
      commit('setAuthStatus', false);
      return true;
    },
    
    checkAuth({ commit }) {
      const userJson = localStorage.getItem('user');
      const isAuth = localStorage.getItem('isAuthenticated') === 'true';

      console.log('Local Storage User:', userJson);
      console.log('Local Storage isAuthenticated:', isAuth);

      if (userJson && isAuth) {
        try {
          const user = JSON.parse(userJson);
          commit('setUser', user);
          commit('setAuthStatus', true);
        } catch (e) {
          console.error('Error parsing user data from local storage:', e);
          localStorage.removeItem('user');
          localStorage.removeItem('isAuthenticated');
          commit('setAuthStatus', false);
        }
      } else {
        commit('setAuthStatus', false);
      }
    },

    async verifyPassword(context, password) {
      try {
        const currentUser = context.getters.currentUser;

        const response = await window.axios.post(window.bankApi + 'Super_admin/login', {
          email: currentUser.email,
          password: password,
          localid: generateUUID()
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Api-Key': 'f6fef6af-0fca-49fe-bec4-89ddb6d24502'
          }
        });

        return !!response.data.response;
      } catch (error) {
        console.error('Password verification failed:', error);
        Swal.fire('Error', 'Password verification failed', 'error')
        return false;
      }
    }
  }
}; 